
import { deleteCarteImage } from '../../context/infopersonContext/apiCalls';
import { InfopersonContext } from '../../context/infopersonContext/InfopersonContext';
import './imageLoader.css';
import { useContext } from 'react';
import { IMAGE_DECHARGE_URL } from "../../config/runtimeConfig";

export default function ImageLoader({ imageLabel, fileDecharge, setFileDecharge, imgUrl, subPath, imgWidth, imgHeight }) {
    const { dispatch } = useContext(InfopersonContext);
    
    return (
        <div className="image-loader">
            {
                imgUrl ? (
                    <div className="image-loader-container">
                        <img src={`${IMAGE_DECHARGE_URL}/${subPath}/${imgUrl}`} alt="" style={imgWidth && imgHeight ? { width: imgWidth, height: imgHeight } : {}} />
                        <span className="material-symbols-rounded shareCancelImg" onClick={() => deleteCarteImage(dispatch)}>delete</span>
                    </div>
                ) : (
                    <>
                        <label htmlFor="file">
                            <span style={{ color: 'tomato' }} className="material-symbols-rounded shareIcon">perm_media</span>
                            <span className="image-loader-text">{imageLabel}</span>
                            <input
                                style={{ display: "none" }}
                                type="file"
                                id="file"
                                accept=".png,.jpeg,.jpg"
                                onChange={(e) => setFileDecharge(e.target.files[0])}
                            />
                        </label>

                        {fileDecharge && (
                            <div className="image-loader-container">
                                <img src={URL.createObjectURL(fileDecharge)} alt="" />
                                <span className="material-symbols-rounded shareCancelImg" onClick={() => setFileDecharge(null)}>close</span>
                            </div>
                        )}
                    </>
                )
            }
        </div>
    )
}
